import { DownloadIcon } from '@global-engineering-shared/gweb-material-icons-global-next';
import { Button } from '@global-engineering-shared/gweb-material-ui';
import MenuItem from '@material-ui/core/MenuItem';
import React from 'react';

import useStyles from 'features/DataManagement/components/ActionButton/ActionButton.styles';
import { useDownloadDataFile } from 'hooks/useDownloadFile';
import { DATA_MANAGEMENT_DATA_API_URL } from 'utils/defaults';

type DownloadActionButtonProps = {
  dataType: string;
  uploadInProgress: boolean;
  handleClose: () => void;
};

const DownloadActionButton = ({
  dataType,
  uploadInProgress,
  handleClose,
}: DownloadActionButtonProps) => {
  const classes = useStyles();
  const { downloadFile, isDataLoading } = useDownloadDataFile();

  const handleDownload = async () => {
    const url = `${DATA_MANAGEMENT_DATA_API_URL}/${dataType.toUpperCase()}/download`;
    const filename = `${dataType}.csv`;
    await downloadFile(url, filename);
    handleClose();
  };

  return (
    <MenuItem key="Download CSV" disableGutters className={classes.menuItem}>
      <Button
        startIcon={<DownloadIcon data-testid="download-icon" />}
        disabled={uploadInProgress || isDataLoading}
        className={classes.actionButton}
        onClick={handleDownload}
      >
        Download CSV
      </Button>
    </MenuItem>
  );
};

export default DownloadActionButton;
